import React from 'react';
export function SalespersonRequirementTable() {
  return <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden mb-8" data-id="element-477">
      <div className="bg-green-600 px-6 py-4" data-id="element-478">
        <h3 className="text-xl font-bold text-white" data-id="element-479">
          Salesperson / Associate Broker — 24 Hour Requirement
        </h3>
        <p className="text-green-100 text-sm mt-1" data-id="element-480">
          24-Hour CE Package — Salesperson & Associate Broker
        </p>
      </div>
      <div className="overflow-x-auto" data-id="element-481">
        <table className="w-full text-left border-collapse" data-id="element-482">
          <tbody data-id="element-483">
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-484">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-485">
                Agency Law
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-486">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-487">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-488">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-489">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-490">
                Contract Law
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-491">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-492">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-493">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-494">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-495">
                Disclosure
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-496">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-497">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-498">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-499">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-500">
                Fair Housing
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-501">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-502">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-503">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-504">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-505">
                Real Estate Legal Issues
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-506">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-507">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-508">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-509">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-510">
                Requirements for Licensees (formerly Commissioner's
                Standards/Rules)
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-511">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-512">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-513">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-514">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-515">
                Firewise, Deed Fraud & Arizona Water
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-516">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-517">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-200" data-id="element-518">
                  New 2025
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-200 hover:bg-gray-50" data-id="element-519">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-520">
                Elective (any approved CE topic)
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-521">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-522">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-50 text-purple-700 border border-purple-200" data-id="element-523">
                  Your choice
                </span>
              </td>
            </tr>
            <tr className="bg-gray-50 font-bold" data-id="element-524">
              <td className="px-6 py-4 text-gray-900 text-right" data-id="element-525">Total</td>
              <td className="px-6 py-4 text-brand-purple-600 whitespace-nowrap" data-id="element-526">
                24 hrs
              </td>
              <td data-id="element-527"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}
export function BrokerRequirementTable() {
  return <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden mb-8" data-id="element-528">
      <div className="bg-green-600 px-6 py-4" data-id="element-529">
        <h3 className="text-xl font-bold text-white" data-id="element-530">
          Designated, Self-Employed & Delegated Associate Brokers — 30 Hour
          Requirement
        </h3>
        <p className="text-green-100 text-sm mt-1" data-id="element-531">
          30-Hour CE Package — Designated & Delegated Brokers
        </p>
        <p className="text-green-100 text-xs mt-0.5 italic" data-id="element-532">
          Includes required Broker Management Clinic (BMC) courses
        </p>
      </div>
      <div className="overflow-x-auto" data-id="element-533">
        <table className="w-full text-left border-collapse" data-id="element-534">
          <tbody data-id="element-535">
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-536">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-537">
                Agency Law
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-538">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-539">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-540">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-541">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-542">
                Contract Law
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-543">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-544">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-545">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-546">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-547">
                Disclosure
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-548">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-549">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-550">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-551">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-552">
                Fair Housing
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-553">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-554">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-555">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-556">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-557">
                Real Estate Legal Issues
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-558">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-559">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-560">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-561">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-562">
                Broker Management Clinic 1 (BMC 1)
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-563">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-564">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-565">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-566">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-567">
                Broker Management Clinic 2 (BMC 2)
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-568">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-569">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-570">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-571">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-572">
                BMC 3A — if brokerage does NOT do property management
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-573">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-574">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-575">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-576">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-577">
                BMC 3B — if brokerage DOES do property management
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-578">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-579">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-580">
                  Required
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-100 hover:bg-gray-50" data-id="element-581">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-582">
                Firewise, Deed Fraud & Arizona Water
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-583">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-584">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-200" data-id="element-585">
                  New 2025
                </span>
              </td>
            </tr>
            <tr className="border-b border-gray-200 hover:bg-gray-50" data-id="element-586">
              <td className="px-6 py-3 text-gray-900 font-medium" data-id="element-587">
                Elective (any approved CE topic)
              </td>
              <td className="px-6 py-3 text-gray-600 whitespace-nowrap" data-id="element-588">
                3 hrs
              </td>
              <td className="px-6 py-3 text-right" data-id="element-589">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-50 text-purple-700 border border-purple-200" data-id="element-590">
                  Your choice
                </span>
              </td>
            </tr>
            <tr className="bg-gray-50 font-bold" data-id="element-591">
              <td className="px-6 py-4 text-gray-900 text-right" data-id="element-592">Total</td>
              <td className="px-6 py-4 text-brand-purple-600 whitespace-nowrap" data-id="element-593">
                30 hrs
              </td>
              <td data-id="element-594"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}